











import Vue from 'vue';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Getter } from 'vuex-class';
import Component from 'vue-class-component';
import { AUTH_LOADING_MODE } from '@/types/authentication.types';

@Component({})
export default class AuthLoading extends Vue {
  @Getter(AUTH_LOADING_MODE, StoreNamespace.AUTHENTICATION) public authLoadingMode!: boolean;
}

